export async function fetchVideoById(id: string | number, noAddress = false) {
  return http
    .get<Video.Detail>('/v1/video/get', {
      id,
      noAddress: noAddress ? 1 : 0,
      html: 1
    })
    .then((res) => res.data)
}
